import { lazy } from 'react';
import ComponentLoader from 'src/components/ComponentLoader';
import Module from 'src/config/models/Module';
import ModuleBundle from 'src/config/models/ModuleBundle';

export const ItemGroupViewModule = new Module({
  id: 'ITEM_GROUP:RESULT-TABLE',
  name: 'Item Group',
  label: 'Item Group',
  path: 'item-group',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/ItemGroup/View'))
  ),
  actions: {
    edit: {
      id: 'ITEM_GROUP:VIEW:*',
      name: 'VIEW',
      label: 'View'
    },
    delete: {
      id: 'item-group-delete',
      name: 'delete',
      label: 'Delete'
    }
  }
});

export const ItemGroupAddModule = new Module({
  id: 'ITEM_GROUP:ADD:*',
  name: 'itemGroupAdd',
  path: 'item-group/add',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/ItemGroup/Form'))
  ),
  actions: {
    add: {
      id: 'ITEM_GROUP:ADD:*',
      name: 'Item Group Add',
      label: 'Add Item Group'
    }
  }
});

export const ItemGroupEditModule = new Module({
  id: 'ITEM_GROUP:VIEW:DETAILS',
  name: 'Item Group Edit',
  path: 'item-group/details/:itemGroupId',
  Component: ComponentLoader(
    lazy(() => import('src/content/management/ItemGroup/Form'))
  )
});

const ItemGroupModules = [ItemGroupViewModule, ItemGroupAddModule, ItemGroupEditModule];

export default new ModuleBundle('ItemGroup', ItemGroupModules);
